import moment from 'moment';
import domainModel from 'domain-model';
import _ from 'lodash';

const { getWeekdayNumber } = domainModel.deliveryRules;

export const weekdays = [
  { key: 'mon', value: 'Måndag' },
  { key: 'tue', value: 'Tisdag' },
  { key: 'wed', value: 'Onsdag' },
  { key: 'thu', value: 'Torsdag' },
  { key: 'fri', value: 'Fredag' },
  { key: 'sat', value: 'Lördag' },
  { key: 'sun', value: 'Söndag' },
];

export const weekdayMap = _.keyBy(weekdays, 'key');

// eslint-disable-next-line import/prefer-default-export
export function calculateDaysEarlierWeekday(
  weekday: string | undefined,
  daysBefore: any,
  date: string | undefined,
) {
  let daysEarlierWeekday;
  if (weekday) {
    const momentWeekday = getWeekdayNumber(weekday);
    const todayDate = moment(moment().format('YYYY-MM-DD'));
    const todayWeekday = todayDate.weekday();
    if (todayWeekday < momentWeekday) {
      todayDate.add(momentWeekday - todayWeekday, 'days');
    } else if (todayWeekday > momentWeekday) {
      todayDate.subtract(todayWeekday - momentWeekday, 'days');
    }
    todayDate.subtract(daysBefore, 'days');
    daysEarlierWeekday = todayDate.weekday();
  } else {
    daysEarlierWeekday = moment(date).subtract(daysBefore, 'days').weekday();
  }
  return daysEarlierWeekday;
}
